<app-timeline-transport-edit-row-modal [assignment]='this.currentJobAssignment'></app-timeline-transport-edit-row-modal>
<app-timeline-transport-new-job [job]='this.newJob'></app-timeline-transport-new-job>
<app-timeline-transport-job-information [job]='this.currentJob' (closed)='this.onJobInfoDrawerClosed()'></app-timeline-transport-job-information>
<app-timeline-transport-vor-and-absence [record]='this.activeVorAbsenceRecord' [type]='this.activeVorAbsenceType' (closed)='this.onVorAbsenceInfoDrawerClosed()'></app-timeline-transport-vor-and-absence>
<app-timeline-transport-copy-jobs></app-timeline-transport-copy-jobs>
<app-timeline-transport-copy-job-to-unit [date]='this.date' [job]='this.copyJob'></app-timeline-transport-copy-job-to-unit>
<app-timeline-transport-add-assignment-note></app-timeline-transport-add-assignment-note>

@if (this.isLoading) {
  <div class='timelineSkeleton'>
    @for (row of [1,2,3]; track row) {
      <div class='timelineSkeletonRow'>
        <div class='timelineSkeletonHeader'></div>
        <div class='timelineSkeletonBlocks'>
          <div class='timelineSkeletonBlock'></div>
          <div class='timelineSkeletonBlock'></div>
          <div class='timelineSkeletonBlock'></div>
        </div>
      </div>
    }
  </div>
} @else {

@if (this.jobAssignments.length === 0) {
  <div class='timelineEmptyState'>
    <i class="fas fa-truck-loading"></i>
    No units available for this date. Please add a unit to start.
  </div>
}

@if (this.hasNoUnitsMatchingSearch()) {
  <div class='timelineEmptyState'>
    <i class="fas fa-search"></i>
    No units match your search.
  </div>
}

@if (
  (this.timelineSettings.timelineOrientationTipper && this.orderTypeId === 3) ||
  (this.timelineSettings.timelineOrientationGrab && this.orderTypeId === 5) ||
  (this.timelineSettings.timelineOrientationConcrete && this.orderTypeId === 6) ||
  (this.timelineSettings.timelineOrientationSweeper && this.orderTypeId === 7) ||
  (this.timelineSettings.timelineOrientationShredder && this.orderTypeId === 8) ||
  (this.timelineSettings.timelineOrientationTanker && this.orderTypeId === 9) ||
  (this.timelineSettings.timelineOrientationArtic && this.orderTypeId === 4)
  ) {
  @if (this.jobAssignments.length > 0 || this.vorAndAbsence.vor.length > 0 || this.vorAndAbsence.absence.length > 0) {
    <table class='jobAllocationTable'>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th style='padding-right: 4rem;'>&nbsp;</th>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody id='mainTimelineBody'>
        <!-- FIRST ROW USED FOR HEADER CHECKBOXES -->
        <tr class='selectors'>
          <td>
            <div style='width:16rem'>&nbsp;</div>
          </td>
          <td>&nbsp;</td>
          <td>
            <div class='allocationContainer'>
              @for (blocki of this.getEmptySlotAsArray(); track blocki) {
                <div class='blockContainer'>
                  <input
                    type='checkbox'
                    [value]='blocki'
                    (click)='onSelectAllCheckboxClicked($event,blocki)'
                    [checked]='isSelectAllSelected(blocki)'
                    title='Select all jobs in this time slot'
                    />
                </div>
              }
            </div>
          </td>
          <td>&nbsp;</td>
        </tr>
        @for (v of this.vorAndAbsence.vor; track v) {
          <tr class='infoRow' (click)='this.openVorAbsenceInfo(v, "vor")'>
            <td colspan='4'>
              <span class='infoRowLabel'>Vehicle off road</span>
              <span class='infoRowDetail'>{{ v.vehicle.registration }}</span>
            </td>
          </tr>
        }
        @for (a of this.vorAndAbsence.absence; track a) {
          <tr class='infoRow' (click)='this.openVorAbsenceInfo(a, "absence")'>
            <td colspan='4'>
              <span class='infoRowLabel'>Driver absence</span>
              <span class='infoRowDetail'>{{ a.driver.firstName }} {{ a.driver.lastName }}</span>
            </td>
          </tr>
        }
        @for (item of this.jobAssignments; track item) {
          <tr [attr.data-ja-id]='item.id' [style.display]="this.matchesUnitSearch(item) ? null : 'none'">
            <td title='Phone: {{getContact(item)}}, Notes: {{ item.notes }}'>
              <div class='roundHeaderHorizontal' [class.sub]='item.subcontractorId !== -1'>
                <input type="checkbox"
                  class='roundHeaderCheckbox'
                  [checked]='this.isAssignmentBoxChecked(item)'
                  (click)='onSelectedAssignmentCheckbox($event,item)'
                  />
                <div class='roundHeaderMain'>
                  @if (item.vehicleId !== -1) {
                    <span class="fas fa-fw fa-truck"></span> {{ item.vehicle.registration }} <span class="far fa-fw fa-id-card"></span> {{ item.driver.firstName + ' ' + item.driver.lastName }} ({{ item.driverStartTime }})
                  }
                  @if (item.subcontractorId !== -1 && item.subcontractorId !== 0) {
                    <span class="far fa-fw fa-id-card"></span> {{ item.subcontractor.name }} ({{ item.driverStartTime }})
                  }
                  <!-- <span *ngIf='item.upcomingInspection !== undefined' class='text-danger'>Inspection Due: {{item.upcomingInspection}}</span> -->
                </div>
                <div class='roundHeaderActions'>
                  <button class='btn btn-primary btn-small' (click)='this.openEditModal(item)'><i class="fas fa-pencil-alt" style='font-size: 0.8rem'></i></button>
                  <button class='btn btn-danger btn-small' (click)='this.deleteJobAssignment(item.id)'><i class="fas fa-trash" style='font-size: 0.8rem'></i></button>
                  <button class='btn btn-info btn-small' (click)='this.copyJobs(item)'><i class="fas fa-copy" style='font-size: 0.8rem'></i></button>
                </div>
              </div>
            </td>
            <td>&nbsp;</td>
            <td>
              <div class='allocationContainer'>
                @for (blocki of this.getEmptySlotAsArray(); track blocki) {
                  @if (!this.getJobByJobAssignmentIdAndBlockId(item.id, blocki)) {
                    <div
                      class='blockContainer'
                      (dragenter)='this.dragEnter($event, item)'
                      (dragleave)='this.dragLeave($event)'
                      (drop)='this.onOrderDrop($event, blocki, item.id)'
                      (dragover)='$event.preventDefault();'
                      >
                      <input
                        type='checkbox'
                        (click)='onEmptySlotChecked($event, item.id, blocki)'
                        [checked]='isEmptySlockCheckChecked(item.id, blocki)'
                        />
                      <div
                        class='timelineBlock'
                        [class.drop]='this.currentHoveredEmptySlot === blocki'
                        [attr.data-id]='blocki'
                        >
                      </div>
                    </div>
                  }
                  @if (this.getJobByJobAssignmentIdAndBlockId(item.id, blocki)) {
                    <div
                      class='blockContainer'
                      [attr.title]='this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).timelineNotes'
                      (dragover)='$event.preventDefault();'
                      (drop)='this.onOrderDropOnJob($event, blocki, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                      (dragenter)='this.dragEnterJob($event, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                      (dragleave)='this.dragLeaveJob($event, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                      >
                      <input
                        type='checkbox'
                        [disabled]='!this.isCheckboxActive(getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                        [checked]='this.isBoxChecked(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                        (click)='onSelectedCheckbox($event,this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                        />
                      <div
                        [attr.title]='this.getHoverText(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                        class='timelineBlock allocated'
                        [class.jobInfoActive]='this.activeJobInfoId === this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).id'
                        [class.statusFilteredOut]='!this.jobMatchesStatusFilter(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                        (click)='this.openOrderModal(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                        [class.drop]='this.curenntHoveredJob === this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).id'
                        (dragstart)='this.dragStart($event, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                        (dragend)='this.dragEnd($event)'
                        draggable='true'
                        [style.background-color]='this.getColorCodeForJob(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                        >
                        <div class='timelineBlockInfo'>
                          <strong>{{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).time }} </strong>
                          {{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.account.name }} - {{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.site.name }}
                          @if (this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.grade !== null && this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.grade !== undefined && this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.grade.name) {
                            <br /><span class='blockDetailLabel'>Grade</span> {{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.grade.name }}
                          }
                          @if (this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.tipSite !== null && this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.tipSite !== undefined) {
                            <span class='blockDetailLabel'>TO</span> {{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.tipSite.name }}
                          }
                        </div>
                        @if (this.getAvatarUrlForJob(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki)) !== null) {
                          <img
                            class='timelineBlockAvatar'
                            [src]='this.getAvatarUrlForJob(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                            [attr.title]='this.getAvatarNameForJob(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                            />
                        }
                        <div class='qty'>
                          <div class='qtyNo'>{{ this.getPODQtyForJobId(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki)) }} {{ this.getUnitForJob(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki)) }}(s)</div>
                        </div>
                        @if (this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).driverJobStatusId !== -1 && this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).driverJobStatusId !== null) {
                          <div class='jobStatus'>
                            <div class='jobStatusName'>{{ this.getDriverStatus(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).driverJobStatusId) }}</div>
                          </div>
                        }
                      </div></div>
                    }
                  }
                </div>
              </td>
              <td>
                <i class="fas fa-plus-square" (click)='addEmptySlot()'></i>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  }

  @if (
    (!this.timelineSettings.timelineOrientationTipper && this.orderTypeId === 3) ||
    (!this.timelineSettings.timelineOrientationGrab && this.orderTypeId === 5) ||
    (!this.timelineSettings.timelineOrientationConcrete && this.orderTypeId === 6) ||
    (!this.timelineSettings.timelineOrientationSweeper && this.orderTypeId === 7) ||
    (!this.timelineSettings.timelineOrientationShredder && this.orderTypeId === 8) ||
    (!this.timelineSettings.timelineOrientationTanker && this.orderTypeId === 9) ||
    (!this.timelineSettings.timelineOrientationArtic && this.orderTypeId === 4)
    ) {
    <div class='timelineRoundsContainer row'>
      @for (item of this.jobAssignments; track item; let i = $index) {
        <div class='timelineRound col-6' >
          <table>
            <tr>
              <td>
                <div class="roundHeader" [class.sub]='item.subcontractorId !== -1'>
                  <div>
                    <br />
                    @if (item.vehicleId !== -1) {
                      <span class="fas fa-fw fa-truck"></span> {{ item.vehicle.registration }}
                      <span class="far fa-fw fa-id-card"></span> {{ item.driver.firstName + ' ' + item.driver.lastName }} ({{ item.driverStartTime }})
                      <br/>
                      @if (getContact(item) !== "" && getContact(item)) {
                        <span class="fas fa-fw fa-phone"></span>
                        } {{getContact(item)}}
                        <br/>
                        @if (item.upcomingInspection !== undefined) {
                          <span class='text-danger'>Inspection Due: {{item.upcomingInspection}}</span>
                        }
                      }
                      @if (item.subcontractorId !== -1 && item.subcontractorId !== 0) {
                        <span class="far fa-fw fa-id-card"></span> {{ item.subcontractor.name }} ({{ item.driverStartTime }})
                      }
                    </div>
                    <button class='btn btn-primary btn-small' (click)='openEditModal(item)'><i class="fas fa-pencil-alt"></i></button>
                  </div>
                </td>
              </tr>
              @for (blocki of this.getEmptySlotAsArray(); track blocki) {
                <tr>
                  <td>
                    @if (!this.getJobByJobAssignmentIdAndBlockId(item.id, blocki)) {
                      <div
                        class='blockContainer'
                        >
                        <input
                          type='checkbox'
                          disabled='disabled'
                          />
                        <div
                          class='timelineBlock'
                          [class.drop]='this.currentHoveredEmptySlot === blocki'
                          [attr.data-id]='blocki'
                          (dragenter)='this.dragEnter($event, item)'
                          (dragleave)='this.dragLeave($event)'
                          (drop)='this.onOrderDrop($event, blocki, item.id)'
                          (dragover)='$event.preventDefault();'
                          >
                        </div>
                      </div>
                    }
                    @if (this.getJobByJobAssignmentIdAndBlockId(item.id, blocki)) {
                      <div
                        class='blockContainer'
                        >
                        <input
                          type='checkbox'
                          [disabled]='!this.isCheckboxActive(getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          [checked]='this.isBoxChecked(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          (click)='onSelectedCheckbox($event,this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          />
                        <div
                          [attr.title]='this.getHoverText(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          class='timelineBlock allocated'
                          [class.statusFilteredOut]='!this.jobMatchesStatusFilter(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          (dragover)='$event.preventDefault();'
                          (drop)='this.onOrderDropOnJob($event, blocki, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          [class.drop]='this.curenntHoveredJob === this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).id'
                          (dragenter)='this.dragEnterJob($event, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          (dragleave)='this.dragLeaveJob($event, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          (dragstart)='this.dragStart($event, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          (dragend)='this.dragEnd($event)'
                          draggable='true'
                          [style.background-color]='this.getColorCodeForJob(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'
                          >
                          <strong>{{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).time }} </strong>
                          {{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.account.name }} - {{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.site.name }}
                          <div class='qty'>
                            <div class='qtyNo'>{{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).qty }}</div>
                          </div>
                        </div>
                      </div>
                    }
                  </td>
                </tr>
              }
              <tr>
                <i class="fas fa-plus-square" (click)='addEmptySlot()'></i>
              </tr>
            </table>
            <!-- <div
            class="roundContainer"
            [class.drop]='this.currentHoveringRoundId === item.id'
            [attr.data-id]='item.id'
            (dragenter)='this.dragEnter($event, item)'
            (dragleave)='this.dragLeave($event)'
            (drop)='this.onOrderDrop($event,0,item.id)'
            (dragover)='$event.preventDefault();'>
            <ng-container *ngFor='let job of item.jobs'>
              <div
                class='orderContainer'
                [class.dragging]='this.draggingId == job.id'
                data-id='{{ job.id }}'
                draggable="true"
                (dragstart)='dragStart($event, job)'
                (dragend)='dragEnd($event)'
                [style.background-color]='this.getColourForJobStatus(job.jobStatusId)'
                *ngIf='this.job.jobStatusId !== 3'>
                <input
                  type='checkbox'
                  [disabled]='!this.isCheckboxActive(getJobByJobAssignmentIdAndBlockId(item.id, 0))'
                  [checked]='this.isBoxChecked(this.getJobByJobAssignmentIdAndBlockId(item.id, 0))'
                  (click)='onSelectedCheckbox($event,this.getJobByJobAssignmentIdAndBlockId(item.id, 0))'
                  />
                <strong>{{job.time}} | {{ job.order.account.name }} - {{job.order.site.name}}</strong><br />
              </div>
            </ng-container>
          </div> -->
        </div>
      }
    </div>
  }

}
